/*********************************************************************
 * © Copyright IBM Corp. 2022
 * Copyright © 2022 Randori https://randori.com - All Rights Reserved.
 *********************************************************************/
import { isNotEmpty as _isNotEmpty, isNotNil as _isNotNil, isNotNilOrEmpty as _isNotNilOrEmpty } from '@randori/rootkit'

export const isNotEmpty = _isNotEmpty
export const isNotNil = _isNotNil
export const isNotNilOrEmpty = _isNotNilOrEmpty
